import {Component, inject, Input, OnInit} from "@angular/core";

import {StudentExam} from "../../../dashboard/feature/studentDashboard/studentDashboard.component";
import {StatusFormatterPipe} from "../../../dashboard/feature/studentDashboard/statusFormatter.pipe";

@Component({
    selector: 'ExamStatusComponent',
    imports: [],
    templateUrl: './exam-status.component.html'
})
export class ExamStatusComponent implements OnInit {
  @Input('exam') exam: StudentExam | undefined;
  statusFormatterPipe = inject(StatusFormatterPipe);
  @Input('fixedWidth') fixedWidth: number = -1;
  readyStyle = 'bg-[#118D5729] text-[#118D57] px-[6px] py-[4px] rounded-[4px]'
  inProgressStyle = 'bg-[#B76E0029] text-[#B76E00] px-[6px] py-[4px] rounded-[4px]'
  completedStyle = 'bg-[#006EBE29] text-[#006EBE] px-[6px] py-[4px] rounded-[4px]'
  outOfTimeStyle = 'bg-[#E5454529] text-[#E54545] px-[6px] py-[4px] rounded-[4px]'

  ngOnInit(): void {
    if(this.fixedWidth > 0) {
      this.readyStyle += ` w-[${this.fixedWidth}px]`
      this.inProgressStyle += ` w-[${this.fixedWidth}px]`
      this.completedStyle += ` w-[${this.fixedWidth}px]`
      this.outOfTimeStyle += ` w-[${this.fixedWidth}px]`
    }
  }
}
